/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZzzOff = createReactComponent("zzz-off", "IconZzzOff", [
  ["path", { d: "M4 12h6l-6 8h6", key: "svg-0" }],
  ["path", { d: "M14 4h6l-5.146 6.862m1.146 1.138h4", key: "svg-1" }],
  ["path", { d: "M3 3l18 18", key: "svg-2" }]
]);

export { IconZzzOff as default };
//# sourceMappingURL=IconZzzOff.js.map
